const LevelEndType = {};
export default LevelEndType;

LevelEndType.USER = "user";
LevelEndType.TIMEOUT = "timeout";